import { JsonObject, JsonProperty } from "json2typescript";
import { ClientLoginInterface } from "../interfaces/client-login.interface";

@JsonObject("ClientLogin")
export class ClientLogin implements ClientLoginInterface {
    Domain?: string;
    Language?: string;
    Password?: string;
    UserName?: string;
    DeviceId?: string;
    ForceLogin?: boolean;

    constructor(obj?: any) {
        Object.assign(this, obj);
    }
}